import React from 'react';

import { Header } from '../components/Header';
import { SideMenu } from '../components/SideMenu';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <div className="flex flex-1 w-full">
        <SideMenu />
        <main className="flex-1 px-[50px] py-[45px] bg-white" aria-label="メインコンテンツ">
          {children}
        </main>
      </div>
    </div>
  );
};
